export type OperationType = 'delete' | 'changePos' | 'create';

export interface DomRect {
  // top left
  x1: number;
  y1: number;
  // bottom right
  x2: number;
  y2: number;
}

export interface ModalDomRect {
  id: string;
  operation: OperationType;
  modalRect: DomRect;
}

export class DomManipulate {
  static addScriptToDocumentHead(src: string, load: () => void, error?: () => void): void {
    const scriptEl = document.createElement('script');

    scriptEl.src = src;
    scriptEl.onload = load ? () => load() : () => {};
    scriptEl.onerror = error ? () => error() : () => {};

    document.head.appendChild(scriptEl);
  }

  /**
   * Calculates if rectangle A intersects with rectangle B
   *
   * @param a {Object} containt (x1, y1) - top left point, (x2, y2) - bottom right point - coordinates of a rectangle
   * @param b {Obbect} same as a parameter
   * @returns {boolean}
   */
  static domIntersect = function (a: DomRect, b: DomRect) {
    return (
      (((a.x1 >= b.x1 && a.x1 <= b.x2) || (a.x2 >= b.x1 && a.x2 <= b.x2)) &&
        ((a.y1 >= b.y1 && a.y1 <= b.y2) || (a.y2 >= b.y1 && a.y2 <= b.y2))) ||
      (((b.x1 >= a.x1 && b.x1 <= a.x2) || (b.x2 >= a.x1 && b.x2 <= a.x2)) &&
        ((b.y1 >= a.y1 && b.y1 <= a.y2) || (b.y2 >= a.y1 && b.y2 <= a.y2))) ||
      (((a.x1 >= b.x1 && a.x1 <= b.x2) || (a.x2 >= b.x1 && a.x2 <= b.x2)) &&
        ((b.y1 >= a.y1 && b.y1 <= a.y2) || (b.y2 >= a.y1 && b.y2 <= a.y2))) ||
      (((b.x1 >= a.x1 && b.x1 <= a.x2) || (b.x2 >= a.x1 && b.x2 <= a.x2)) &&
        ((a.y1 >= b.y1 && a.y1 <= b.y2) || (a.y2 >= b.y1 && a.y2 <= b.y2)))
    );
  };
}
